module.exports = __webpack_public_path__ + "img/spk__arrow-right.99cf0dab.svg";